import { injectResource } from "./injectResource";

// NOTE: globalize & cldr were removed as they're used for localization and we're not doing that
// see: https://js.devexpress.com/jQuery/Documentation/19_2/Guide/Common/Localization/
require("devextreme/dist/js/dx.viz-web.js");

// NOTE: theme registration previously in devextreme-solovis-custom.js
DevExpress.viz.registerTheme(
  {
    name: "solovis.custom",
    defaultPalette: "Office",
  },
  "generic.light"
);
DevExpress.viz.currentTheme("solovis.custom");

// Requiring CSS files will cause esbuild to emit a merged fila named after the entry
require("devextreme/dist/css/dx.common.css");
require("devextreme/dist/css/dx.light.css");
// So then we inject the emitted CSS files into the document
injectResource("/vendors/devextreme.css");
// validated: esbuild